module.exports = __webpack_public_path__ + "static/media/consultation.470208e9.jpg";